module.exports = __webpack_public_path__ + "img/engrais_md.88fc73d0.jpg";